import React from 'react';
import './Header.css';
import logo from '../Images/insurdinary-header-logo.png';

const Header = () => {
    return (
        <div className='header-div'>
            <div>
                <img className='logo-image' src={logo} height={30} alt="insurdinary logo"/>
            </div>
        </div>
    )
}

export default Header;